module.exports = __webpack_public_path__ + "static/media/m2.f0c76eb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/map-cluster-icons/m2.png
// module id = 507
// module chunks = 0